import { register } from "@autosync/ats-web-components";

/**
 * Automatically register all AutoSync web components.
 */
export default defineNuxtPlugin(() => {
  register();
});
